import { render, staticRenderFns } from "./GenialGuardPlans.vue?vue&type=template&id=0ca96b5b"
import script from "./GenialGuardPlans.vue?vue&type=script&lang=js"
export * from "./GenialGuardPlans.vue?vue&type=script&lang=js"
import style0 from "./GenialGuardPlans.vue?vue&type=style&index=0&id=0ca96b5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports